<template>
  <img src="@/assets/images/error.png" style="width: 100%">
</template>

<style scoped>

</style>